<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="assetSignedStudents"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.activa"
          :disabled="pagination.showLoadingState"
          :elements="estados"
          keyField="id"
          name="tipo_estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.search"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="alumno@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionMapEnrollmentsDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        :disabled="!element.publicado"
        @showModal="$modal.showModal"
      />

      <form
        autocomplete="off"
        class="m-form-row margin-left-auto"
        name="download-csv-form"
        @submit.prevent="readInscripcionesProyectoExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !alumnosInscriptos.length"
        />
      </form>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="alumnosInscriptos.length">
          <th
            class="text-align-left"
            width="26%"
          >
            {{ $t('mEditionMapEnrollmentsStudents.table.thStudent') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionMapEnrollmentsStudents.table.thDateAcademy') }}
          </th>
           <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionMapEnrollmentsStudents.table.thDateMap') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionMapEnrollmentsStudents.table.thProgress') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionMapEnrollmentsStudents.table.thStars') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionAssetSignedStudents.table.thContent') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionAssetSignedStudents.table.thAccess') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionMapEnrollmentsStudents.table.thState') }}
          </th>
        </tr>
        <tr
          v-for="alumno in alumnosInscriptos"
          :key="alumno.id"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-flex-row-center">
              <AtomAvatarSecondary
                avatar-class="medium"
                :user-image="alumno.avatar"
              />
              <span class="display-flex-column user-info">
                <span class="ellipsis">
                  {{ alumno.razon_social ? alumno.razon_social : alumno.email }}
                </span>
                <small :class="['ellipsis font-weight-regular', alumno.activa ? 'text-color-primary-80' : 'text-color-danger']">
                  {{ alumno.email }}
                </small>
              </span>
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            <span class="display-flex-column">
               <span>{{ $moment.parseZone(alumno.fecha_alta_actor).format('D MMM YYYY') }}</span>
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
           <span class="display-flex-column">
               <span>{{ $moment.parseZone(alumno.fecha).format('D MMM YYYY') }}</span>
            </span>
          </td>
          <td class="text-align-center">
            <div class="a-radialprogress">
              <div>
                <div
                  :class="overallPercentage(alumno.porcentaje_nodos_vistos) < 50
                    ? `progress-circle p${overallPercentage(alumno.porcentaje_nodos_vistos)} under50`
                    : `progress-circle p${overallPercentage(alumno.porcentaje_nodos_vistos)} over50`"
                >
                <span :class="overallPercentage(alumno.porcentaje_nodos_vistos) > 0 ? `text-color-maps-primary` : `text-color-primary-80`">{{overallPercentage(alumno.porcentaje_nodos_vistos)}}%</span>
                  <div :class="['left-half-clipper', parseInt(alumno.porcentaje_nodos_vistos).toFixed(0) < 50 ? 'left-half-clipper-under50' : 'left-half-clipper-over50']">
                    <div class="first50-bar first-maps-color"></div>
                    <div class="value-bar value-maps-color"></div>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td class="text-align-center">
            <span class="display-flex-column">
              <span class="font-size-medium">
                {{ alumno.puntos }}
                <i :class="alumno.puntos == 0 ? 'font-size-medium fas fa-star text-color-primary-40' : 'font-size-medium fas fa-star text-color-notifications-primary'"></i>
              </span>
              <small class="text-color-primary-80 font-size-xsmall">
                  {{ alumno.familia ? alumno.familia : "Sin Equipo"}}
              </small>
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.content"
              :element="alumno"
              @gotToMapEnrollmentsStudentContents="gotToMapEnrollmentsStudentContents"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.access"
              :disabled="requests.createAcademiaActorResetPassword.isRequested &&
                requests.createAcademiaActorResetPassword.itemLoading !== alumno.alumno"
              :element="alumno"
              :show-loading="requests.createAcademiaActorResetPassword.isRequested &&
                requests.createAcademiaActorResetPassword.itemLoading === alumno.alumno"
              @createAcademiaActorResetPassword="createAcademiaActorResetPassword(alumno.alumno)"
            />
          </td>
          <td class="text-align-center">
             <span
              class="a-tooltip-primary a-tooltip-bottom"
              :data-tooltip-text="alumno.activa ? $t('mEditionMapEnrollmentsStudents.tooltip.deactivate') : $t('mEditionMapEnrollmentsStudents.tooltip.activate')"
            >
              <AtomTogglePrimary
                v-model="alumno.activa"
                :disabled="requests.updateInscripcionEstado.isRequested"
                :element-id="alumno.id_inscripcion"
                method="updateInscripcionEstado"
                name="activo"
                :show-loading="requests.updateInscripcionEstado.isRequested &&
                  requests.updateInscripcionEstado.itemLoading === alumno.id_inscripcion"
                sliderClass="a-toggle-slider-maps-primary"
                type="checkbox"
                @updateInscripcionEstado="updateInscripcionEstado"
              />
             </span>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionMapEnrollmentsStudents',

  components: {
    MoleculeEditionMapEnrollmentsDropDownFilters: () => import('@/components/molecules/MoleculeEditionMapEnrollmentsDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      alumnosInscriptos: '',

      buttonIconRounded: {
        access: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-unlock-alt',
          method: 'createAcademiaActorResetPassword',
          tooltip: this.$t('mEditionMapEnrollmentsStudents.tooltip.access'),
          type: 'button'
        },

        add: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionMapEnrollmentsStudentsModalAdd',
          icon: 'far fa-user-plus',
          method: 'showModal',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsStudents.tooltip.add'),
          type: 'button'
        },

        content: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToMapEnrollmentsStudentContents',
          tooltip: this.$t('mEditionMapEnrollmentsStudents.tooltip.content'),
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionMapEnrollmentsStudents.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-maps-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        create: {
          class: 'a-button-maps-secondary a-button-side',
          component: 'MoleculeEditionMapEnrollmentsStudentsModalCreate',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: this.$t('mEditionMapEnrollmentsStudents.buttonSecondary.createText'),
          type: 'button'
        },

        filter: {
          class: 'a-button-maps-secondary a-button-side',
          component: 'MoleculeEditionAssetSignedStudentsDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionMapEnrollmentsStudents.buttonSecondary.filterText'),
          type: 'button'
        },

        reload: {
          class: 'a-button-maps-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsStudents.tooltip.reload'),
          type: 'button'
        }
      },

      estados: [
        {
          id: '',
          name: 'Todos los estados'
        },
        {
          id: 1,
          name: 'Activas'
        },
        {
          id: 0,
          name: 'Inactivas'
        }
      ],

      filter: {
        activa: '1',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        search: ''
      },

      inscripcionesTipo: [
        {
          class: 'ellipsis font-weight-regular text-color-danger',
          id: 0,
          name: this.$t('mEditionMapEnrollmentsStudents.enrollment.automatic')
        },
        {
          class: 'ellipsis font-weight-regular text-color-success',
          id: 1,
          name: this.$t('mEditionMapEnrollmentsStudents.enrollment.manual')
        }
      ],

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      requests: {
        createAcademiaActorResetPassword: {
          itemLoading: '',
          isRequested: false
        },

        updateInscripcionEstado: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true,

      simpleFilter: {
        activa: 1,
        search: ''
      }
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = true
      this.readInscripcionesProyecto()
    }
  },

  created () {
    this.readInscripcionesProyecto()
  },

  methods: {
    createAcademiaActorResetPassword (actorId) {
      if (!this.requests.createAcademiaActorResetPassword.isRequested) {
        this.requests.createAcademiaActorResetPassword.isRequested = true
        this.requests.createAcademiaActorResetPassword.itemLoading = actorId
        this.$services.create('academia', 'createAcademiaActorResetPassword', {}, [this.$store.getters.getAcademyData.id, actorId])
          .then(response => {
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudents', 'createAcademiaActorResetPassword', 'success')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudents', 'createAcademiaActorResetPassword', 'error', 'a-alert-danger')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
      }
    },

    gotToMapEnrollmentsStudentContents (alumno) {
      this.$store.commit('setAssetSelectedStudent', alumno)
      this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.enrollments.subject')}/${alumno.id_inscripcion}/${this.$t('mEditionMenu.map.enrollments.children.contents.subedition')}`)
    },

    overallPercentage (porcentaje) {
      return parseInt(porcentaje).toFixed(0)
    },

    readInscripcionesProyecto () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('inscripcion', 'readInscripcionesProyecto', {}, [this.element.id], this.filter)
          .then(response => {
            this.alumnosInscriptos = []
            this.alumnosInscriptos = response.data.inscripciones
            console.log(this.alumnosInscriptos)
            this.pagination.currentQuantity = this.alumnosInscriptos.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.alumnosInscriptos = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readInscripcionesProyectoExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('inscripcion', 'readInscripcionesProyectoExportar', {}, [this.element.id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionMapEnrollmentsStudents.files.student')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudents', 'readInscripcionesProyectoExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudents', 'readInscripcionesProyectoExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        activa: '1',
        eliminada: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        search: ''
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        activa: 1,
        search: ''
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.resetSimpleFilter()
      this.simpleFilter.activa = advancedFilter.activa === '1' ? 1 : advancedFilter.activa === '0' ? 0 : ''
      this.simpleFilter.search = advancedFilter.search
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.search) ||
        this.simpleFilter.search === '') {
        this.resetAdvancedFilter()
        this.filter.activa = this.simpleFilter.activa
        this.filter.search = this.simpleFilter.search
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readInscripcionesProyecto()
    },

    updateInscripcionEstado (element) {
      if (!this.requests.updateInscripcionEstado.isRequested) {
        this.requests.updateInscripcionEstado.isRequested = true
        this.requests.updateInscripcionEstado.itemLoading = element.id
        this.$services.update('inscripcion', 'updateInscripcionEstado', { estado: element.state }, [element.id])
          .then(response => {
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudents', 'updateInscripcionEstado', response.data.activo ? 'activationSuccess' : 'deactivationSuccess')
            this.requests.updateInscripcionEstado.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.alumnosInscriptos[this.alumnosInscriptos.findIndex(alumno => alumno.id_inscripcion === element.id)].activa = +!element.state
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudents', 'updateInscripcionEstado', 'error', 'a-alert-danger')
            this.requests.updateInscripcionEstado.isRequested = false
          })
      }
    }
  }
}
</script>
